module.exports = __webpack_public_path__ + "img/niño85.3b64a0b2.jpg";